// @flow

import { type InstalmentsPlan } from '../../types';

export function getInstalmentsNumber(instalmentsPlan: InstalmentsPlan): number {
  return instalmentsPlan['instalments'];
}
